import { render, staticRenderFns } from "./info4.vue?vue&type=template&id=0d33b3e3"
import script from "./info4.vue?vue&type=script&lang=js"
export * from "./info4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports